
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialSection from './TestimonialKeyword';
import FaqSection from './FAQKeyword';
import GTag from '../components/GTag';
import KeywordProtectedPage from './MyPage';
function Borivalitopunecabs() {



    const cardData =
    {
        keyword: 'Borivali to Pune Cab',
        heading: 'Mauli Cabs: Borivali to Pune Cab',
        headingDescription: 'Mauli Cabs offers reliable and comfortable Borivali to Pune cab services, ensuring a smooth and stress-free journey from the bustling suburb of Borivali in Mumbai to your destination in Pune. Whether you are traveling for business, leisure, or a family visit, we provide a range of well-maintained vehicles including sedans, SUVs, and premium cabs to suit your needs. With professional drivers, transparent pricing, no hidden charges, and a strong focus on punctuality and customer satisfaction, Mauli Cabs guarantees a safe and hassle-free ride from Borivali to Pune.',

        top: 'Top Places to Visit in Pune with Mauli Cabs',

"topPlaces": [
    {
        "title": "Shaniwar Wada",
        "description": "A historic fortification in the heart of Pune, Shaniwar Wada was the seat of the Peshwas of the Maratha Empire and is known for its majestic architecture and legends."
    },
    {
        "title": "Aga Khan Palace",
        "description": "Built in 1892, the Aga Khan Palace is a beautiful monument of national importance, known for its connection to Mahatma Gandhi and India's freedom movement."
    },
    {
        "title": "Sinhagad Fort",
        "description": "Located around 30 km from Pune, Sinhagad Fort is a popular trekking spot with rich historical significance and panoramic views of the Sahyadri hills."
    },
    {
        "title": "Pataleshwar Cave Temple",
        "description": "An 8th-century rock-cut temple carved out of a single basalt rock, Pataleshwar Cave Temple is dedicated to Lord Shiva and offers a peaceful spiritual retreat."
    },
    {
        "title": "Dagdusheth Halwai Ganpati Temple",
        "description": "One of the most famous Ganpati temples in Maharashtra, this temple is known for its rich history, beautiful idol, and grand Ganesh Chaturthi celebrations."
    },
    {
        "title": "Raja Dinkar Kelkar Museum",
        "description": "This museum houses an impressive collection of over 20,000 artifacts showcasing Indian arts, crafts, and culture, curated by Dr. Dinkar Kelkar."
    },
    {
        "title": "Parvati Hill and Temple",
        "description": "Parvati Hill is one of the oldest heritage sites in Pune, offering a temple complex atop a hill with stunning views of the city."
    },
    {
        "title": "Osho Ashram",
        "description": "Located in Koregaon Park, Osho Ashram is a spiritual retreat offering meditation programs and a serene environment, attracting visitors from around the world."
    },
    {
        "title": "Pune Okayama Friendship Garden",
        "description": "Also known as Pu La Deshpande Garden, this is a Japanese-style landscape garden perfect for relaxing walks and photography."
    },
    {
        "title": "Katraj Snake Park and Rajiv Gandhi Zoological Park",
        "description": "This zoo and snake park features a wide variety of reptiles and animals, making it a favorite spot for families and children."
    }
],

"services": [
    {
      "name": "Borivali to Pune Cab Service",
      "description": "Book a reliable and comfortable cab service from Borivali to Pune. Whether you're traveling for business, leisure, or an emergency, our professional drivers ensure a smooth, stress-free journey. Choose from a variety of vehicles to suit your preferences and travel in comfort."
    },
    {
      "name": "Borivali to Pune Car",
      "description": "For a comfortable and efficient journey from Borivali to Pune, choose from our wide selection of cars. From compact sedans to spacious SUVs, each vehicle is maintained to the highest standards, ensuring a pleasant and timely ride."
    },
    {
      "name": "Borivali to Pune Taxi",
      "description": "Enjoy a hassle-free and timely taxi service from Borivali to Pune. Our fleet of well-maintained vehicles is available 24/7, providing you with an affordable, comfortable, and safe ride every time you travel."
    },
    {
      "name": "Borivali to Pune Taxi Service",
      "description": "Book a reliable taxi service from Borivali to Pune at competitive rates. Whether it's a short trip or a long journey, our drivers ensure punctuality, professionalism, and comfort during the entire ride."
    },
    {
      "name": "Borivali to Pune Taxi Fare",
      "description": "Check out our transparent and affordable taxi fare for the journey from Borivali to Pune. We offer competitive rates with no hidden charges, ensuring you get the best value for your money while enjoying a safe and comfortable ride."
    },
    {
      "name": "Borivali to Pune Cab",
      "description": "Enjoy a seamless ride with our premium cab service from Borivali to Pune. Our fleet includes a variety of vehicles ranging from sedans to SUVs, each driven by professional drivers who prioritize your comfort and punctuality."
    },
    {
      "name": "Pune to Borivali Cab",
      "description": "Travel conveniently from Pune to Borivali with our efficient cab service. Whether you’re coming for business or leisure, we provide a smooth and punctual ride in well-maintained vehicles that ensure a comfortable journey."
    },
    {
      "name": "Cab Service in Borivali",
      "description": "Get the best cab service in Borivali for local and outstation travel. Our fleet includes a variety of vehicles to match your requirements, ensuring you travel comfortably within Borivali or to destinations like Pune, Mumbai, and beyond."
    },
    {
      "name": "Taxi Service in Borivali",
      "description": "Choose a dependable taxi service in Borivali for all your travel needs. From quick local rides to long-distance trips, our professional drivers ensure you reach your destination on time, safely and comfortably."
    },
    {
      "name": "Innova Crysta on Rent in Borivali",
      "description": "Rent a Toyota Innova Crysta in Borivali for your trips to Pune or other destinations. Ideal for families or larger groups, this vehicle offers luxurious comfort, spacious seating, and excellent air conditioning, making it perfect for long journeys."
    },
    {
      "name": "Borivali to Pune Innova Crysta",
      "description": "Travel from Borivali to Pune in the spacious and luxurious Toyota Innova Crysta. This vehicle offers superior comfort, ample space for luggage, and a smooth ride, making it an ideal choice for family trips, group travel, or business excursions."
    },
    {
      "name": "Borivali to Pune Ertiga Cab",
      "description": "For a comfortable ride from Borivali to Pune, opt for a Maruti Ertiga cab. Perfect for families or small groups, the Ertiga offers generous space for passengers and luggage while ensuring a smooth and comfortable ride."
    },
    {
      "name": "Mumbai to Pune Cab Booking",
      "description": "Book a convenient and reliable cab from Mumbai to Pune for a smooth and stress-free journey. Our fleet includes a variety of vehicles, and we offer affordable rates with professional drivers who ensure a comfortable and timely ride."
    }
  ],
  "tableData": [
    ["Borivali to Pune Cab Service", "Borivali to Pune Car"],
    ["Borivali to Pune Taxi", "Borivali to Pune Taxi Service"],
    ["Borivali to Pune Taxi Fare", "Borivali to Pune Cab"],
    ["Pune to Borivali Cab", "Cab Service in Borivali"],
    ["Taxi Service in Borivali", "Innova Crysta on Rent in Borivali"],
    ["Borivali to Pune Innova Crysta", "Borivali to Pune Ertiga Cab"],
    ["Mumbai to Pune Cab Booking", ""]
  ],


"whychoose": [
    {
        "WhyChooseheading": "Reliable Cab Service from Borivali to Pune",
        "WhyChoosedescription": "Mauli Cabs offers dependable, punctual, and comfortable cab services from Borivali to Pune. Whether for business, leisure, or any other trip, we ensure a seamless journey to Pune."
    },
    {
        "WhyChooseheading": "Comfortable and Clean Vehicles",
        "WhyChoosedescription": "Travel in comfort with our well-maintained, air-conditioned sedans, SUVs, and premium vehicles. All cabs are regularly sanitized to ensure a smooth and hygienic journey from Borivali to Pune."
    },
    {
        "WhyChooseheading": "Experienced Drivers Familiar with the Route",
        "WhyChoosedescription": "Our experienced drivers know the best routes for a smooth, timely trip from Borivali to Pune. They are skilled at avoiding traffic and navigating the Mumbai-Pune Expressway for an efficient journey."
    },
    {
        "WhyChooseheading": "Affordable and Transparent Pricing",
        "WhyChoosedescription": "Mauli Cabs offers transparent, competitive pricing for your Borivali to Pune ride. No hidden fees—just upfront, fair pricing for a comfortable journey."
    },
    {
        "WhyChooseheading": "24/7 Availability for Your Convenience",
        "WhyChoosedescription": "Whether it's an early morning meeting or a late-night travel need, Mauli Cabs operates 24/7, ensuring you can get a ride from Borivali to Pune at any time."
    },
    {
        "WhyChooseheading": "Easy Booking and Real-Time Updates",
        "WhyChoosedescription": "Book your cab easily via our website or mobile app. Track your ride in real-time, get updates on driver details, and stay informed throughout your journey from Borivali to Pune."
    },
    {
        "WhyChooseheading": "Safe, Sanitized, and Secure Travel",
        "WhyChoosedescription": "Safety is our priority. All vehicles are sanitized regularly, and drivers are background-verified. We follow strict safety protocols to ensure a secure ride from Borivali to Pune."
    },
    {
        "WhyChooseheading": "Flexible Payment Options",
        "WhyChoosedescription": "Pay your way with UPI, credit/debit cards, wallets, or cash. Mauli Cabs offers a variety of secure payment options to make your Borivali to Pune trip more convenient."
    }
]


























    }

    const faqData = [
        {
            question: 'How do I book a cab from Borivali to Pune with Mauli Cabs?',
            answer: 'Booking a cab from Borivali to Pune with Mauli Cabs is quick and easy. Simply visit our website or mobile app, enter "Borivali" as your pickup location and "Pune" as your drop location. Choose your preferred vehicle type and confirm the booking. Our customer support team is available 24/7 if you need any assistance.',
        },
        {
            question: 'What types of cabs are available for the Borivali to Pune route?',
            answer: 'Mauli Cabs offers a variety of vehicles for your journey from Borivali to Pune, including Hatchbacks, Sedans, SUVs, Ertiga, Innova Crysta, and luxury cars. Select the vehicle that best suits your needs for comfort, luggage, and group size.',
        },
        {
            question: 'Is the fare from Borivali to Pune fixed?',
            answer: 'Yes, the fare from Borivali to Pune is fixed and includes all charges like tolls, fuel, driver fees, and taxes. The complete fare will be shown before you confirm your booking, with no hidden charges.',
        },
        {
            question: 'How long does the journey from Borivali to Pune take?',
            answer: 'The travel time from Borivali to Pune typically takes 3.5 to 5 hours, depending on traffic and road conditions. It’s recommended to start early or avoid peak travel hours to reach Pune faster.',
        },
        {
            question: 'Can I book a one-way or round-trip cab from Borivali to Pune?',
            answer: 'Yes, Mauli Cabs provides both one-way and round-trip options. If you plan to return on the same or the next day, a round-trip booking is more economical.',
        },
        {
            question: 'Can I schedule an early morning or late-night pickup from Borivali?',
            answer: 'Yes, Mauli Cabs operates 24/7, so you can schedule your pickup from Borivali at any time of the day or night, whether it’s for an early morning flight or a late-night ride.',
        },
        {
            question: 'Can I carry extra luggage on my Borivali to Pune trip?',
            answer: 'Yes, extra luggage is allowed. For more or bulkier luggage, we recommend booking a larger vehicle such as an SUV or Innova Crysta for added space and comfort.',
        },
    ];
    
    const testimonials = [
        {
            name: "Mr. Akash Jadhav",
            position: "Software Engineer",
            text: "I traveled from Borivali to Pune with Mauli Cabs and the experience was excellent. The car was comfortable, the driver was courteous, and the journey was smooth. I highly recommend their services for long-distance travel!",
            image: "/img/testimonial/testimonial-thumb-1-39.png",
        },
        {
            name: "Miss. Neha Pandit",
            position: "Travel Blogger",
            text: "Booked a cab from Borivali to Pune for a weekend getaway. The booking process was seamless, the car was clean, and the driver was professional. A great travel experience overall. I will definitely use Mauli Cabs again!",
            image: "/img/testimonial/testimonial-thumb-1-40.png",
        },
    ];
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    









    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 7972733209",
            "+91 9763272775",

        ],
        email: "booking@maulicabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Pune to Mumbai Car Rental",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Shirdi Cab Booking",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Mahabaleshwar Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Lonavala - Khandala Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune to Mumbai Airport Taxi",
        },
        {
            place: "/images/keyword/6.jpg",
            text: " Pune to Adlabs Imagica Cab Booking ",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Best Cab Service For Matheran",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Ganpatipule Cab Booking",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Pune to Pandharpur Cab Booking",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Pune to Jyotirlinga Tour Package",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pune to Ashtavinayak Darshan Cab",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Best Cab From Pune to Murud Janjira",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Pune to Alibaug Affordable Cab",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Pune to Ajanta Ellora Cab",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Pune to Aurangabad Cab Booking",
        },
        {
            place: "/images/keyword/16.jpg",
            text: "Pune to Sade Teen Shakti Peeth Cab",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Pune to Bhimashankar Round Trip",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Pune Trimbakeshwar Best Cab",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune to Nashik and Igatpuri Cab",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Pune to Kolhapur Cab Booking",
        },

        {
            place: "/images/keyword/22.jpg",
            text: "Pune to Satara Cab Booking",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Tarkarli - Malvan Cab",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Pune to Outstation Cab",
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Pune to Goa Cab Booking",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Pune to Tuljapur Cab ",
        },
        {
            place: "/images/keyword/27.jpg",
            text: "Pune to Alandi - Dehu Darshan Cab",
        },
    ];


    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];


    const jsonData = {
        "@context": "https://schema.org",
        "@type": "Product",
        "name": "Borivali to Pune Cab",
        "description": "Mauli Cabs offers dependable and comfortable taxi service from Borivali to Pune. Choose from Innova Crysta, Ertiga, or sedan vehicles for one-way or round-trip travel at affordable fares.",
        "aggregateRating": {
          "@type": "AggregateRating",
          "bestRating": "5",
          "worstRating": "1",
          "ratingValue": "4.7",
          "ratingCount": "5465"
        }
      };
      
     
      


    return (
        <div>
            <GTag/>
<KeywordProtectedPage/>

<Helmet>
        <title>Borivali to Pune Cab | Mauli Cabs | Call +91 7972733209</title>
        <meta
          name="description"
          content="Book a Borivali to Pune cab with Mauli Cabs. Reliable taxi service with Innova Crysta, Ertiga, or sedan options. Affordable fares, smooth ride, and professional drivers from Borivali to Pune."
        />
        <meta
          name="keywords"
          content="borivali to pune cab service, borivali to pune car, borivali to pune taxi, borivali to pune taxi service, borivali to pune taxi fare, borivali to pune cab, pune to borivali cab, cab service in Borivali, taxi service in borivali, innova crysta on rent in borivali, borivali to pune innova crysta, borivali to pune ertiga cab, mumbai to pune cab booking"
        />
        <script type="application/ld+json">
          {JSON.stringify(jsonData)}
        </script>
      </Helmet>

            <section
                className="vs-breadcrumb"
                style={{ backgroundImage: 'url(/img/bg/breadcrumb-bg-2.png)' }}
            >
                <div className="container">
                    <div className="row text-center">
                        <div className="col-12">
                            <div className="breadcrumb-content">
                                <h1 className="breadcrumb-title">{cardData.keyword}</h1>
                            </div>
                        </div>
                    </div>
                </div>
            </section>





            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/99.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2 bg-foootr'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Mauli Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialSection testimonials={testimonials} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #631D02',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#631D02' }}>
                                            <h4 className=" lead fw-semibold whitt textt-dark">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+917972733209" className="d-block  text-white">+91 7972733209</a>
                                                <a href="tel:+919763272775" className="d-block  text-white">+91 9763272775</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#631D02' }}>
                                                <h4 className=" fw-semibold lead whitt textt-dark">Email</h4>
                                                <a href="mailto:booking@maulicabs.com" className=" text-white d-block">
                                                    booking@maulicabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#631D02' }}>
                                                <h4 className=" fw-semibold lead whitt textt-dark">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Mauli Cabs <br />
                                                    Pune Alandi Road , Wadmukkhwadi Charholi Bk, Alandi Devachi , Khed , Pune 412105
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Borivalitopunecabs;